export default "__VITE_ASSET__DKzX6DjB__"